import React from "react";
import "./App.css";
import { Body } from "./components/Body";

const App: React.FC = () => {
  return (
    <div className="app">
      <Body />
    </div>
  );
};

export default App;
